export const stock_balance_byStock = [
  {
    id: 1,
    materialName: "Material 1",
    type: "material type 1",
    unit: "unit 1",
    balance: 150,
  },
  {
    id: 2,
    materialName: "Material 2",
    type: "material type 2",
    unit: "unit 2",
    balance: 150,
  },
  {
    id: 3,
    materialName: "Material 3",
    type: "material type 4",
    unit: "unit 2",
    balance: 150,
  },
  {
    id: 4,
    materialName: "Material 4",
    type: "material type 4",
    unit: "unit 1",
    balance: 150,
  },
]
export const stock_balance_byMaterial = [
    {
      id: 1,
      stockName: "Stock-1",
      balance: "100"
    },
    {
      id: 2,
      stockName: "Stock-2",
      balance: "200"
    },
    {
      id: 3,
      stockName: "Stock-3",
      balance: "300"
    },
    {
      id: 4,
      stockName: "Stock-4",
      balance: "400"
    },
  ]